import {
  AccountBalance,
  Assignment,
  Build,
  Business,
  CreditCard,
  Error,
  LocalAtm,
  Receipt,
  SupervisorAccount,
} from '@mui/icons-material';
import { DataModelType } from '/src/lib/types';

export * from './FuseIcon';
export * from './FuseLogo';
export * from './LoanIcon';

export const dataModelIcons: Record<string, React.ReactElement> = {
  [DataModelType.Account]: <></>,
  [DataModelType.Adjustment]: <Build />,
  [DataModelType.Advance]: <CreditCard />,
  [DataModelType.Alert]: <Error />,
  [DataModelType.Asset]: <Receipt />,
  [DataModelType.Company]: <Business />,
  [DataModelType.Lender]: <AccountBalance />,
  [DataModelType.Loan]: <AccountBalance />,
  // [DataModelType.Loan]: <LoanIcon white width="24px" height="24px" />,
  [DataModelType.Note]: <></>,
  [DataModelType.Participation]: <AccountBalance />,
  [DataModelType.Payment]: <LocalAtm />,
  [DataModelType.Report]: <></>,
  [DataModelType.Statement]: <Assignment />,
  [DataModelType.Transaction]: <></>,
  [DataModelType.User]: <SupervisorAccount />,
};
